import { render, staticRenderFns } from "./rx9.vue?vue&type=template&id=67ac3f91&scoped=true&"
import script from "./rx9.vue?vue&type=script&lang=js&"
export * from "./rx9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ac3f91",
  null
  
)

export default component.exports